import { ComponentType } from 'react';
import { Location, createBrowserHistory } from 'history';

interface TypeRoute {
  name: string;
  path: string;
  component?: ComponentType<any>;
  redirectTo?: string;
  public?: boolean;
}

interface Arguments {
  [key: string]: string | number | null | undefined;
}

class RouterService {
  routes: TypeRoute[] = [];

  register(routes: TypeRoute[]) {
    this.routes = routes.sort((a, b) => b.path.length - a.path.length);
    return this;
  }

  getRouteFromPath(path: string): TypeRoute | undefined {
    return this.routes.find(route => route.path === path);
  }

  getRoute(name: string): TypeRoute | undefined {
    return this.routes.find(route => route.name === name);
  }

  getPath(name: string | undefined, args: Arguments = {}): string {
    if (!name) {
      return '';
    }
    const route = this.getRoute(name);

    return route
      ? route.path.replace(/(:([\w]+))/gi, (_all, _match, key): any => {
          return args[key] || '';
        })
      : '';
  }

  isActive(routeName: string, location: Location): boolean {
    const route = this.getRoute(routeName);
    if (!route) {
      return false;
    }
    const pattern = route.path.replace(/(:([\w]+))/gi, '[^/]+');
    const regexp = RegExp(`^${pattern}$`, 'i');
    return regexp.test(location.pathname);
  }
}

export const history = createBrowserHistory();

export const Router = new RouterService();
